export default function () {
  return {
    current: {
      id: '',
      name: '',
      acronym: '',
      description: '',
      parent: null,
      tagType: null,
      resources: []
    },
    update: {
      id: '',
      name: '',
      acronym: '',
      description: '',
      parent: null,
      tagType: null
    },
    list: []
  }
}
